// mock 数据定义（直接放在本文件顶部）
import api from './api';
import { getCurrentUser } from './authService';
import endpoints from './endpoints';

const mockProposals = [
  {
    id: 'mock-id-1',
    prompt: 'Mock Proposal 1',
    response: 'This is a mock proposal.',
    thumb: '',
    mask: { image: 1, color: 2 },
    topics: ['ai_competition'],
    is_public: 'true',
    created: {
      avatar:
        'http://14.103.140.194:5001/v1/syntrust/attachments/bc57217f-4e28-430a-9781-647eb61ad533/download?img_token=SFMyNTY.g2gDdAAAAARtAAAADWF0dGFjaG1lbnRfaWRtAAAAJGJjNTcyMTdmLTRlMjgtNDMwYS05NzgxLTY0N2ViNjFhZDUzM20AAAADZXhwYmh3Ul9tAAAABHR5cGVtAAAADGltYWdlX2FjY2Vzc20AAAAHdXNlcl9pZG0AAAAkMDU1MDc4ZGMtZThmMS00NTBkLTg4NGEtMzJjMzZmZGU2N2EwbgYAzAgMEpgBYgABUYA.lEupHbqaALpoPLLHrfg9gieQIw36FnvRvTyb6xXmo_w',
      id: 'f17f502b-4ad8-4a82-af6c-804ce205c257',
      nickname: 'tonggggggggg',
    },
    inserted_at: '2025-05-22T09:22:05Z',
    attachments: [
    ],
    reviews: [
      {
        id: 'review-1',
        content: '这是一个很好的提案，思路清晰，实现方案可行。',
        rating: 4.5,
        inserted_at: '2025-01-15T10:30:00Z',
        user: {
          id: 'user-1',
          nickname: '评审员A',
          avatar: 'https://via.placeholder.com/40x40/2196F3/FFFFFF?text=A',
        },
      },
      {
        id: 'review-2',
        content: '提案很有创意，但需要进一步完善细节。',
        rating: 4.0,
        inserted_at: '2025-01-14T15:20:00Z',
        user: {
          id: 'user-2',
          nickname: '评审员B',
          avatar: 'https://via.placeholder.com/40x40/4CAF50/FFFFFF?text=B',
        },
      },
    ],
  },
];
const mockProposalDetail = mockProposals[0];

// 判断是否使用本地模拟数据
const VITE_USE_MOCK_DATA = import.meta.env.VITE_USE_MOCK_DATA === 'true';

/**
 * 获取提案广场列表
 * @param {Object} params
 * @returns {Promise}
 */
export const getProposalSquareList = async (params = {}) => {
  if (VITE_USE_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 800));
    // 获取分页参数
    const page = params.pagination?.page || 1;
    const perPage = params.pagination?.per_page || 20;
    // 返回符合API格式的mock数据
    const mockResponse = {
      pagination: {
        total: mockProposals.length,
        page: page,
        per_page: perPage,
      },
      cards: mockProposals.map((proposal, idx) => ({
        ...proposal,
        colorIdx: idx % 7, // 添加颜色索引
      })),
    };
    return mockResponse;
  }
  try {
    const requestParams = {
      filter: params.filter,
      sort: params.sort,
      pagination: params.pagination || { page: 1, per_page: 20 },
    };
    const response = await api.post(endpoints.proposal.search, requestParams);
    return response;
  } catch (error) {
    console.error('获取提案广场列表失败:', error);
    throw error;
  }
};

/**
 * 参赛作品服务（统一提案/参赛作品相关API）
 */

/**
 * 创建参赛作品（提案）
 * @param {Object} data
 * @returns {Promise}
 */
export const createEntry = async (data) => {
  if (VITE_USE_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return {
      status: 'success',
      code: 200,
      entry_id: `entry_${Date.now()}`,
      message: '参赛作品创建成功 (mock)',
    };
  }
  try {
    // V2 API 数据结构
    const requestData = {
      type: "article",
      fields: {
        category: "competition",  // 竞赛作品类型
        title: data.title || data.prompt || '',
        body_text: data.body_text || data.response || '',
        tags: [...(data.tags || data.topics || []), "ai_competition"],  // 自动添加ai_competition标签
        status: data.status || 'draft',
        cover_image: data.cover_image || data.thumb || null,
        attachments: data.attachments || [],
        mask: data.mask || {},
        group_id: data.group_id || null,
      }
      // 移除permissions字段，让后端根据published状态自动设置权限
    };
    const response = await api.post(endpoints.competition.create, requestData);
    return response;
  } catch (error) {
    console.error('提交参赛作品失败:', error);
    throw error;
  }
};
/**
 * 获取我的参赛作品列表
 * @param {Object} params
 * @returns {Promise}
 */
export const getMyEntryList = async (params = {}) => {
  if (VITE_USE_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 800));
    return {
      pagination: { total: 0, page: 1, per_page: 20 },
      entries: [],
    };
  }
  try {
    const requestParams = {
      params: {
        type: 'article',
        category: 'competition',
        user_id: 'current',
        ...params,
      }
    };
    console.log('getMyEntryList requestParams', requestParams);
    const response = await api.get(endpoints.competition.me, requestParams);
    return response;
  } catch (error) {
    console.error('获取参赛作品列表失败:', error);
    throw error;
  }
};

/**
 * 搜索当前用户的参赛作品 (使用搜索API)
 * @param {Object} searchParams - 搜索参数
 * @returns {Promise}
 */
export const searchMyEntries = async (searchParams = {}, options = {}) => {
  if (VITE_USE_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 800));
    return {
      pagination: { total: 0, page: 1, per_page: 20 },
      contents: [],
    };
  }
  try {
    console.log('searchMyEntries searchParams', searchParams);
    const response = await api.post(endpoints.competition.search, searchParams, '', '', options);
    return response;
  } catch (error) {
    console.error('搜索参赛作品失败:', error);
    throw error;
  }
};

/**
 * 搜索内容 (使用统一内容搜索API)
 * @param {Object} searchParams - 搜索参数
 * @returns {Promise}
 */
export const searchContents = async (searchParams = {}, options = {}) => {
  if (VITE_USE_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 800));
    return {
      pagination: { total: 0, page: 1, per_page: 20 },
      contents: [],
    };
  }
  try {
    console.log('searchContents searchParams', searchParams);
    const response = await api.post(endpoints.competition.search, searchParams, '', '', options);
    return response;
  } catch (error) {
    console.error('搜索内容失败:', error);
    throw error;
  }
};
/**
 * 获取参赛作品列表
 * @param {Object} params
 * @returns {Promise}
 */
export const getEntryList = async (params = {}) => {
  if (VITE_USE_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 800));
    return {
      pagination: { total: 0, page: 1, per_page: 20 },
      entries: [],
    };
  }
  try {
    // V2 API: 使用GET请求with查询参数
    const requestParams = {
      params: {
        type: 'article',
        category: 'competition',
        page: params.pagination?.page || 1,
        limit: params.pagination?.per_page || 20,
        ...params.filter,
        ...params,
      }
    };
    console.log('getEntryList requestParams', requestParams);
    const response = await api.get(endpoints.competition.list, requestParams);
    return response;
  } catch (error) {
    console.error('获取参赛作品列表失败:', error);
    throw error;
  }
};

/**
 * 获取参赛作品详情
 * @param {string} id
 * @returns {Promise}
 */
export const getEntryDetail = async (id) => {

  if (VITE_USE_MOCK_DATA) {
    console.log('Using mock data for entry detail');
    await new Promise((resolve) => setTimeout(resolve, 500));

    // 根据ID查找对应的mock数据，如果找不到则返回第一个
    const mockDetail =
      mockProposals.find((proposal) => proposal.id === id) ||
      mockProposalDetail;
    console.log('Mock detail response:', mockDetail);
    return mockDetail;
  }
  try {
    const response = await api.get(endpoints.competition.detail(id));
    return response;
  } catch (error) {
    console.error('获取参赛作品详情失败:', error);
    throw error;
  }
};

/**
 * 更新参赛作品
 * @param {string} id
 * @param {Object} data
 * @returns {Promise}
 */
export const updateEntry = async (id, data) => {
  try {
    const response = await api.put(
      endpoints.competition.update(id),
      data
    );
    return response;
  } catch (error) {
    console.error('更新参赛作品失败:', error);
    throw error;
  }
};

/**
 * 删除参赛作品
 * @param {string} id
 * @returns {Promise}
 */
export const deleteEntry = async (id) => {
  try {
    const response = await api.delete(endpoints.competition.delete(id));
    return response;
  } catch (error) {
    console.error('删除参赛作品失败:', error);
    throw error;
  }
};

/**
 * 参赛作品评分/评论
 * @param {Object} data { entry_id, content, rating }
 * @returns {Promise}
 */
export const reviewEntry = async (data) => {
  try {
    const requestData = {
      entry_id: data.entry_id,
      content: data.content,
      rating: data.rating,
    };
    const response = await api.post(endpoints.competition.review, requestData);
    return response;
  } catch (error) {
    console.error('参赛作品评分失败:', error);
    throw error;
  }
};

/**
 * 分享参赛作品
 * @param {string} id
 * @returns {Promise}
 */
export const shareEntry = async (id) => {
  try {
    const response = await api.post(endpoints.competition.share(id));
    return response;
  } catch (error) {
    console.error('分享参赛作品失败:', error);
    throw error;
  }
};

/**
 * 点赞/取消点赞参赛作品
 * @param {string} id
 * @returns {Promise}
 */
export const toggleLike = async (id) => {
  if (VITE_USE_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 300));
    return { success: true };
  }
  try {
    const response = await api.post(endpoints.like.toggle(id));
    return response;
  } catch (error) {
    console.error('点赞操作失败:', error);
    throw error;
  }
};

/**
 * 收藏/取消收藏参赛作品
 * @param {string} id
 * @returns {Promise}
 */
export const toggleFavorite = async (id) => {
  if (VITE_USE_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 300));
    return { success: true };
  }
  try {
    const response = await api.post(endpoints.favorite.toggle(id));
    return response;
  } catch (error) {
    console.error('收藏操作失败:', error);
    throw error;
  }
};

/**
 * 获取参赛作品评论列表
 * @param {string} id - 作品ID
 * @param {number} page - 页码
 * @param {number} perPage - 每页数量
 * @returns {Promise}
 */
export const getEntryComments = async (id, page = 1, perPage = 10) => {
  if (VITE_USE_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 500));
    return {
      reviews: [
        {
          id: 'comment-1',
          content: '这个提案很有创意！',
          rating: 5,
          inserted_at: '2025-08-01T10:00:00Z',
          creator: {
            id: 'user-1',
            nickname: '评论用户A',
            avatar: null,
          },
        },
        {
          id: 'comment-2', 
          content: '实现方案很详细，赞！',
          rating: 4,
          inserted_at: '2025-08-01T09:00:00Z',
          creator: {
            id: 'user-2',
            nickname: '评论用户B',
            avatar: null,
          },
        },
      ],
      pagination: {
        page: page,
        per_page: perPage,
        total_pages: 1,
        total: 2,
      },
    };
  }
  try {
    const response = await api.get(endpoints.comment.list(id), {
      params: { page, per_page: perPage },
    });
    return response;
  } catch (error) {
    console.error('获取评论列表失败:', error);
    throw error;
  }
};

/**
 * 添加参赛作品评论
 * @param {string} id - 作品ID
 * @param {string} content - 评论内容
 * @param {number} rating - 评分
 * @returns {Promise}
 */
export const addEntryComment = async (id, content, rating = 5) => {
  if (VITE_USE_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 800));
    return {
      id: `comment-${Date.now()}`,
      content,
      rating,
      inserted_at: new Date().toISOString(),
      creator: {
        id: 'current-user',
        nickname: '当前用户',
        avatar: null,
      },
    };
  }
  try {
    const response = await api.post(endpoints.comment.add(id), {
      id,
      comment: content,
      rating,
    });
    return response;
  } catch (error) {
    console.error('添加评论失败:', error);
    throw error;
  }
};

const competitionService = {
  getProposalSquareList,
  createEntry,
  getMyEntryList,
  searchMyEntries,
  searchContents,
  getEntryList,
  getEntryDetail,
  updateEntry,
  deleteEntry,
  reviewEntry,
  shareEntry,
  toggleLike,
  toggleFavorite,
  getEntryComments,
  addEntryComment,
};

export default competitionService;
